import { render } from "./InstallationView.vue?vue&type=template&id=260074cd&scoped=true"
import script from "./InstallationView.vue?vue&type=script&lang=js"
export * from "./InstallationView.vue?vue&type=script&lang=js"

import "./InstallationView.vue?vue&type=style&index=0&id=260074cd&scoped=true&lang=css"

import exportComponent from "C:\\Users\\47959\\OneDrive\\Documents\\GitHub\\Poesiparken\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-260074cd"]])

export default __exports__